/**
 * WEBPACK_CONIFG_HOST的值，在webpack.config.js中更改
 * 开发环境时 = "http://amptest.wisedu.com/xsfwfw/"
 * 发布环境时 = location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1)) + "/"
 */

export default {
  getSelLetterList: WEBPACK_CONFIG_HOST + "sys/newoadxzxx/getSelLetterList.do",
  getLetterCount: WEBPACK_CONFIG_HOST + "sys/newoadxzxx/getLetterCount.do",
  getDepartment: WEBPACK_CONFIG_HOST + "sys/newoadxzxx/getBoxList.do", // 获取部门数据
  // getAllLetterCount: WEBPACK_CONFIG_HOST + "sys/newoadxzxx/getLetterCount.do" // 获取总数
  getDetail: WEBPACK_CONFIG_HOST + "sys/newoadxzxx/modules/document/T_OA_DXZXX_QUERY.do",
  getUploadedAttachment: WEBPACK_CONFIG_HOST + "sys/emapcomponent/file/getUploadedAttachment.do",
  getYzDcsAttachmentUrl: WEBPACK_CONFIG_HOST + 'sys/oapublic/yzconvert/yzDocForAttachment.do',
}


// WEBPACK FOOTER //
// ./src/api.js